// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-06a241cd]{flex-grow:0;z-index:2}.content[data-v-06a241cd]{overflow:hidden;flex-grow:1;position:relative}.inner-content[data-v-06a241cd]{position:absolute;top:0;left:0;right:0;bottom:0;overflow:auto}.wrapper[data-v-06a241cd]{display:flex;flex-direction:column;height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
